export default __webpack_public_path__ + "static/media/photo--sm--leena-3.a2823935.jpg";